import Ajv from "ajv";

import { lvtResponseSchema } from "@/api/common";


const archiveCabinetProperties = {
    cameraName: { type: "string" },
    clientId: { type: "number" },
    clientName: { type: "string" },
    id: { type: "number" },
    latitude: { type: ["number", "null"] },
    locationName: { type: "string" },
    longitude: { type: ["number", "null"] },
    name: { type: "string" },
    regionName: { type: ["string", "null"] },
};

const archiveCabinetsSchema = lvtResponseSchema({
    type: "array",
    items: {
        type: "object",
        properties: archiveCabinetProperties,
    },
});

export const archiveCabinetsValidator = new Ajv().compile(archiveCabinetsSchema);
